/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ExecuteWithdrawalRequest,
  PrepareWithdrawalRequest,
  PrepareWithdrawalResponse,
  WithdrawalDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiWithdrawalController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-withdrawal-controller
   * @name BookWithdrawal
   * @request POST:/api/v1/withdrawal
   */
  bookWithdrawal = (data: WithdrawalDto, params: RequestParams = {}) =>
    this.http.request<WithdrawalDto, any>({
      path: `/v1/withdrawal`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bookWithdrawalPath = '/v1/withdrawal'
  static bookWithdrawalMethod = 'POST'
  /**
   * No description
   *
   * @tags api-withdrawal-controller
   * @name PrepareWithdrawal
   * @request POST:/api/v1/withdrawal/prepare
   */
  prepareWithdrawal = (data: PrepareWithdrawalRequest, params: RequestParams = {}) =>
    this.http.request<PrepareWithdrawalResponse, any>({
      path: `/v1/withdrawal/prepare`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static prepareWithdrawalPath = '/v1/withdrawal/prepare'
  static prepareWithdrawalMethod = 'POST'
  /**
   * No description
   *
   * @tags api-withdrawal-controller
   * @name ExecuteWithdrawal
   * @request POST:/api/v1/withdrawal/execute
   */
  executeWithdrawal = (data: ExecuteWithdrawalRequest, params: RequestParams = {}) =>
    this.http.request<WithdrawalDto, any>({
      path: `/v1/withdrawal/execute`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static executeWithdrawalPath = '/v1/withdrawal/execute'
  static executeWithdrawalMethod = 'POST'
}
